import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; // ← Add this near your other imp
import {
  Box,
  useToast,
  useColorModeValue,
  Text,
  Spinner,
  VStack,
  Heading,
} from "@chakra-ui/react";
import axios from "axios";
import { PracticeManualAttemptDetails, PracticeManualAttemptDetailsEval, PracticeAttemptScoreStatus } from "../../../Platform/Common/types";
import PracticeAttemptManualEvaluator from "../Components/PracticeAttemptManualEvaluator";

const EvaluatePracticeExamByAdmin = () => {

    const navigate = useNavigate(); // ← Initialize navigation

  const { practice_attempt_id } = useParams<{ practice_attempt_id: string }>();
  const examAttemptId = Number(practice_attempt_id);
  const toast = useToast();

  const [examManualAttemptDetails, setExamManualAttemptDetails] = useState<PracticeManualAttemptDetails | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const cardBg = useColorModeValue("gray.50", "gray.700");

const handleManualSave = async (manualScoringData: PracticeManualAttemptDetailsEval) => {
  const success = await saveManualAttemptToAPI(manualScoringData);
  if (success) {
    toast({
      title: "Evaluation overridden successfully.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });

    navigate(-1); // or navigate("/admin/exam-scoring-status")
  }
};

  const saveManualAttemptToAPI = async (manualScoringData: PracticeManualAttemptDetailsEval): Promise<boolean> => {
  try {
    const api = process.env.REACT_APP_API_URL || 'https://default-url.com';

    await axios.post<PracticeAttemptScoreStatus>(
      `${api}/b2c/practice-exam-attempt/${manualScoringData.practice_attempt_id}/manual-score`,
      manualScoringData,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      }
    );

    return true;
  } catch (error) {
    console.error("Error saving evaluation:", error);
    toast({
      title: "Error occurred while saving override.",
      status: "error",
      duration: 4000,
      isClosable: true,
    });
    return false;
  }
};


  const fetchExamManualAttempt = async (practice_attempt_id: number) => {
    try {
      const api = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const { data } = await axios.get<PracticeManualAttemptDetails>(
        `${api}/b2c/practice-exam-attempt/${practice_attempt_id}/manual-question-details`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` } }
      );
      setExamManualAttemptDetails(data);
    } catch (err) {
      console.error(err);
      toast({ title: "Error fetching exam attempt details", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExamManualAttempt(examAttemptId);
  }, [examAttemptId]);

  return (
    <Box as="main" mx="auto" p={4}>
      <VStack align="start" spacing={4}>
        <Heading size="md" color="blue.600">
          Admin Manual Evaluation Override
        </Heading>
        <Text fontSize="sm" color="gray.600">
          You are now overriding the manual evaluation for this exam attempt. Any changes made here will overwrite previous tutor evaluations and will be recorded for audit purposes.
        </Text>
      </VStack>

      <Box mt={6} bg={cardBg} p={4} borderRadius="md" boxShadow="sm">
        {loading ? (
          <Spinner size="lg" />
        ) : examManualAttemptDetails ? (
          <PracticeAttemptManualEvaluator
            examManualAttemptDetails={examManualAttemptDetails}
            onSubmit={handleManualSave}
          />
        ) : (
          <Text color="red.500">No data found for the specified exam attempt.</Text>
        )}
      </Box>
    </Box>
  );
};

export default EvaluatePracticeExamByAdmin;
